import React from "react";
import './AddButton.css';
import './add_button2.css';
import { useTranslation } from "react-i18next";

const AddButton = ({
    text = 'Add',
    onClick,
    color,
    border, 
    backgroundColor,
    variant = 'default',
    isSubmitting= false // 'default', 'compact'
}) => {
    const {t} = useTranslation();
    const buttonStyle = {};
    if (backgroundColor) {
        buttonStyle.backgroundColor = backgroundColor;
    }
    if (color) {
        buttonStyle.color = color;
    }
    if (border) {
        buttonStyle.border = border;       
    }
    
    return (
        <div 
            onClick={!isSubmitting ? onClick : undefined} // prevent clicks
            className={`add-button common-text ftw-4 ${variant === 'compact' ? 'compact' : ''} ${isSubmitting ? 'disabled' : ''}`}
            style={buttonStyle}
        >
            {t(text)} 
        </div>
    );
};

export default AddButton;